import './style/loginPage.scss';

import {
    AwesomeIcon, ChangeFunction, DvrdButton, DvrdInput, DVRDPasswordInput, ErrorType, Loader, preventDefault
} from '@dvrd/dvr-controls';
import React, {FocusEventHandler, KeyboardEventHandler, MouseEventHandler} from 'react';

interface Props {
    onChangeEmail: ChangeFunction<string>;
    onChangePassword: ChangeFunction<string>;
    onResetError: FocusEventHandler;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    email: string;
    password: string;
    error: ErrorType;
    loading: boolean;
}

export default function LoginPage(props: Props) {
    const {onChangeEmail, onChangePassword, onResetError, onSubmit, email, password, error, loading} = props;
    return (
        <div className='login-page'>
            <form className='form-container' onSubmit={preventDefault}>
                <Loader active={loading}/>
                <DvrdInput value={email} onChange={onChangeEmail} label='E-mailadres' onFocus={onResetError}
                           type='email' inputProps={{autoComplete: 'username'}} onEnter={onSubmit} autoFocus/>
                <DVRDPasswordInput value={password} onChange={onChangePassword} label='Wachtwoord'
                                   onFocus={onResetError} inputProps={{autoComplete: 'current-password'}}
                                   onEnter={onSubmit}/>
                <DvrdButton onClick={onSubmit} label='Inloggen' className='btn-submit'
                            ornaments={{element: <AwesomeIcon name='paper-plane'/>}}/>
            </form>
        </div>
    );
}

LoginPage.displayName = 'LoginPage';